import React from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';


const MyAccountSideBar = () => {

    const tokenDataFromLocalStorage = localStorage.getItem("muskan_token_data");
    const parsedTokenData = tokenDataFromLocalStorage ? JSON.parse(tokenDataFromLocalStorage) : null;

    const navigate = useNavigate();
    const handleLogout = () => {
        localStorage.removeItem('muskan_token');
        localStorage.removeItem('muskan_token_data');
        navigate('/account/login');
    };

    return (
        <div className="card">
            {/* <div className="list-group accolumn px-3">
                <font size="2">Good to see you again</font>
            </div> */}
            <div className="card-header">
           
                    <h6 className=" text-uppercase" ><i className="fa fa-user main-color" aria-hidden="true" style={{ fontSize: "22px" }}></i>
                        &nbsp;      {parsedTokenData ? `${parsedTokenData.customer_fname} ${parsedTokenData.customer_lname}` : 'N/A'}


                    </h6>
              
            </div>
           <div className="card-body">
             <div className="list-group accolumn px-0 pt-0 " style={{boxShadow: "none"}}>


                <ul>
                    <li>
                        <Link to="/account/myprofile">
                            My Profile
                        </Link>
                    </li>
                    <li>
                        <Link to="/account/addressbook">
                            Address Book
                        </Link>
                    </li>
                    <li>
                        <Link to="/account/change-password">
                            Change Password
                        </Link>
                    </li>

                    <li>
                        <Link to="/account/order-history">
                            Order History
                        </Link>
                    </li>

                    <hr />

                    <li>  <Link to="/wishlist">
                        Wish List
                    </Link></li>


                    <li>
                        <Link to="/cart">
                            Cart
                        </Link>
                    </li>

                    <li >
                        <p onClick={handleLogout} style={{ cursor: "pointer" }}>Log out</p>
                    </li>

                </ul>




            </div>
           </div>
        </div>
    );
}

export default MyAccountSideBar;

